export default "__VITE_ASSET__7Lgzkoo0__"